import { render, staticRenderFns } from "./announcementDetails.vue?vue&type=template&id=063f04af&scoped=true&"
import script from "./announcementDetails.vue?vue&type=script&lang=js&"
export * from "./announcementDetails.vue?vue&type=script&lang=js&"
import style0 from "./announcementDetails.vue?vue&type=style&index=0&id=063f04af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f04af",
  null
  
)

export default component.exports